module.exports = __webpack_public_path__ + "img/t_0004.cfcfdc62.gif";